module.exports = __webpack_public_path__ + "img/Canadian.39461d3d.svg";